import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens a Bootstrap modal on connect, cleans up on disconnect.
// Used with turbo_frame_tag "modal" pattern.
export default class extends Controller {
  connect() {
    this.hiddenHandler = this.handleHidden.bind(this)
    this.modal = Modal.getOrCreateInstance(this.element)

    // When user dismisses via backdrop/ESC, clear the turbo frame
    this.element.addEventListener("hidden.bs.modal", this.hiddenHandler)
    this.modal.show()
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this.hiddenHandler)
    this.modal?.dispose()
    this.cleanupArtifacts()
  }

  handleHidden() {
    // Clear the turbo frame so Stimulus controller disconnects cleanly
    const frame = document.getElementById("modal")
    if (frame) frame.innerHTML = ""
    this.cleanupArtifacts()
  }

  cleanupArtifacts() {
    const otherVisibleModals = Array.from(document.querySelectorAll(".modal.show"))
      .some(modalEl => modalEl !== this.element)

    // If this was the last visible modal, force-clear stale page-lock artifacts.
    if (!otherVisibleModals) {
      document.body.classList.remove("modal-open")
      document.body.style.removeProperty("overflow")
      document.body.style.removeProperty("padding-right")
      document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
    }
  }
}
